import React from 'react';
import { Box, Typography } from '@mui/material';
import { useStyles } from './styles';
import { IEvent } from '@interfaces/event';

type SkyLinkEventItemProps = {
  event: IEvent;
  onClick?: () => void;
};

export const SkyLinkEventItem: React.FC<SkyLinkEventItemProps> = ({
  event,
  onClick,
}) => {
  const classes = useStyles();
  return (
    <Box
      onClick={onClick}
      sx={{
        ...classes.root,
        width: 300,
        height: 400,
        cursor: onClick ? 'pointer' : 'default',
        '@media (max-width: 900px)': {
          width: 260,
          height: 360,
          flex: '0 0 auto',
        },
      }}
    >
      <Box sx={classes.image(event.logoImage?.url || event.image)} />

      <Box sx={classes.footer}>
        <Typography variant="subtitle1" sx={classes.title}>
          {event.name}
        </Typography>
      </Box>
    </Box>
  );
};

export default SkyLinkEventItem;
